import React, { memo } from "react";
import {
  FiAlertTriangle,
  FiXCircle,
  FiHelpCircle,
  FiHeart,
  FiShield,
} from "react-icons/fi";

const problemas = [
  {
    icon: FiAlertTriangle,
    text: "Receio de resultados artificiais ou exagerados.",
  },
  {
    icon: FiXCircle,
    text: "Experiências com procedimentos sem acompanhamento adequado.",
  },
  {
    icon: FiHelpCircle,
    text: "Dúvidas sobre segurança e qualidade dos tratamentos.",
  },
  {
    icon: FiHeart,
    text: "Falta de um atendimento realmente acolhedor e humano.",
  },
];

const Problemas = () => {
  return (
    <section
      id="problemas"
      className="problemas"
      aria-labelledby="problemas-title"
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-delay="180"
    >
      <div className="problemas__container">
        {/* =========================
            HEADER
        ========================= */}
        <header className="problemas__header">
          <span className="problemas__subtitle">
            Cuidado • Segurança • Naturalidade
          </span>

          <h2
            className="problemas__title"
            id="problemas-title"
          >
            Você merece resultados{" "}
            <span className="highlight">
              elegantes e seguros
            </span>
          </h2>
        </header>

        {/* =========================
            GRID DE PROBLEMAS
        ========================= */}
        <ul className="problemas__list">
          {problemas.map((item, index) => {
            const Icon = item.icon;

            return (
              <li
                key={index}
                className="problemas__item hover-lift"
              >
                <span className="problemas__icon">
                  <Icon aria-hidden="true" />
                </span>

                <p className="problemas__text">
                  {item.text}
                </p>
              </li>
            );
          })}
        </ul>

        {/* =========================
            SOLUÇÃO
        ========================= */}
        <div className="problemas__solution">
          <h3>
            Na Clínica Catarino, cada paciente é
            atendido com atenção, segurança e foco
            na beleza natural.
          </h3>

          <p>
            Com protocolos personalizados e
            acompanhamento profissional, oferecemos
            tratamentos modernos para elevar sua
            autoestima com leveza e confiança.
          </p>
        </div>
      </div>
    </section>
  );
};

export default memo(Problemas);